import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import { parse } from "qs";

import { getSearchResults } from "../../../actions/search";
import Spinner from "../../../components/Library/Spinner";
import Layout from "../../../components/Library/Layout";
import Sidebar from "../../../components/Library/Layout/Sidebar";
import Content from "../../../components/Library/Layout/Content";
import StoriesStream from "../../../components/Library/StoriesStream";
import Header from "../../../components/Library/Header";

import styles from "./SearchResults.css";

class SearchResults extends Component {
  constructor(props) {
    super(props);

    this.state = {};
    this.loadNextStories = this._loadNextStories.bind(this);
  }

  _loadNextStories(page) {
    return this.props.getSearchResults(this.state.search, page, true);
  }

  componentDidMount() {
    this.props.getSearchResults(this.state.search);
  }

  //changed from the deprecated componentWillReceiveProps
  static getDerivedStateFromProps(props, state){ 
    const nextSearch = parse(props.location.search.slice(1)).q;
    //if new search is not equal to the search value saved in state, set state equal to newest search; 
    if (nextSearch !== state.search){  
      return {
        search: nextSearch, 
      };
    }
    //else, do not return anything, aka do not change state
    return null;  
  }

  componentDidUpdate(prevProps, prevState){
    if (prevState.search !== this.state.search){
      this.props.getSearchResults(this.state.search);
    }
  }

  render() {
    const { search } = this.props;
    if (search.results.length === 0 && search.isLoading) return <Spinner/>;
    const isEmpty = !search.isLoading && search.isFinished && search.results.length === 0;
    const header = <Header className={styles.clipboard} text={`“${this.state.search}”`} subText="Search Results"/>;

    return (
      <Layout includeHeader headerComponent={header}>
        {!isEmpty && <Sidebar>{" "}</Sidebar>}
        <Content className={classNames({ [styles.content]: isEmpty })} ariaLabel="Search results">
          {
            isEmpty ?
              <div className={styles.empty}>
                Your search for “{this.state.search}” did not match any results.
              </div> :

              <StoriesStream
                stories={search}
                isSummary={true}
                showUnread={false}
                next={this.loadNextStories}/>
          }
        </Content>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    search: state.search,
  };
};

export default connect(mapStateToProps, { getSearchResults })(SearchResults);
